import { defineMessages } from 'react-intl'

export const tutorialsMessages = defineMessages({
  title: {
    id: 'tutorials.title',
    description: '"Tutorials" page title',
    defaultMessage: 'Tutorials',
  },
})
